// src/features/reservations/components/ReservationDetailPage.tsx
//
// Full-page reservation detail (mockup 04), route `/reservations/:id`.
// Reached from a Reservas row or from the Llegadas de hoy drawer's
// "Ver ficha completa" link.
import React from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import { ArrowBackRounded as BackIcon } from '@mui/icons-material';
import { useTranslate } from 'react-admin';
import { useNavigate, useParams } from 'react-router-dom';
import { SectionHeader } from '@/components/common/SectionHeader';
import { PageHelp } from '@/components/common/PageHelp';
import { ReservationDetailContent } from './ReservationDetailContent';

export const ReservationDetailPage: React.FC = () => {
  const translate = useTranslate();
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();

  return (
    <Box>
      <SectionHeader manualScreen="reservation-detail"
        title={null}
        left={
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <IconButton size="small" onClick={() => navigate('/reservations')} aria-label="back">
              <BackIcon fontSize="small" />
            </IconButton>
            <Typography variant="h6" fontWeight={700}>
              {translate('resources.reservations.detail.title')}
            </Typography>
          </Box>
        }
        helpConfig={{
          titleKey: 'resources.reservations.help.title',
          descriptionKey: 'resources.reservations.help.description',
          featureKeys: [
            'resources.reservations.help.features.urlFilters',
            'resources.reservations.help.features.rowClick',
            'resources.reservations.help.features.summary',
          ],
        }}
      />
      <Box sx={{ p: { xs: 2, sm: 3 } }}>
        {id ? <ReservationDetailContent reservationId={id} /> : null}
      </Box>
    </Box>
  );
};

export default ReservationDetailPage;
